import { Table, TableName } from '@openx/components-table/Table.tsx';
import type { AllTableCriteria } from '@openx/types/tableCriteria.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getDealsDecidedSensitiveCategoriesColumns } from '../constants.tsx';
import type { DealAdCategoryProposal } from '../model.ts';
import type { DealsSensitiveCategoriesListFilters, ShareDealsSensitiveCategoriesListProps } from '../types.ts';

const DealsSensitiveCategoriesSimpleTable = Table<DealAdCategoryProposal>;

export function DealDecidedSensitiveCategoriesList({
  activeTab,
  items,
  criteria,
  onCriteriaChange,
}: ShareDealsSensitiveCategoriesListProps) {
  const { t } = useTranslation();

  const listCriteria: AllTableCriteria<DealsSensitiveCategoriesListFilters> = useMemo(() => {
    if (criteria.sort && criteria.sort?.column === 'proposedDate') {
      return {
        ...criteria,
        sort: {
          ...criteria.sort,
          column: 'decisionDate',
        },
      };
    }

    return criteria;
  }, [criteria]);

  const columns = useMemo(() => getDealsDecidedSensitiveCategoriesColumns(activeTab, t), [activeTab, t]);

  return (
    <DealsSensitiveCategoriesSimpleTable
      loading={false}
      name={TableName.DEALS_SENSITIVE_CATEGORIES_DECIDED}
      data={items}
      columns={columns}
      criteria={listCriteria}
      onCriteriaChange={onCriteriaChange}
    />
  );
}
